import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IStudentResults } from '@interfaces/IStudentResults';
import { IUser } from '@interfaces/IUser';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StudentResultsViewService {
  constructor(private _http: HttpClient) {}

  get(groupId: number, userId: number): Observable<IStudentResults> {
    const url = `${environment.baseUrl}api/v1/users/${userId}/groups/${groupId}/results/`;
    return this._http.get<IStudentResults>(url);
  }

  postAppealReview(workReviewId: number, text: string) {
    const url = `${environment.baseUrl}api/v1/student-works-reviews/${workReviewId}/challenge/`;
    return this._http.post(url, { id: workReviewId, text: text });
  }

  closeAppealReview(workReviewId: number, reviewer: IUser) {
    const url = `${environment.baseUrl}api/v1/student-works-reviews/${workReviewId}/challenge_close/`;
    return this._http.post(url, { reviewer });
  }
}
